<template>
    <div>
        <PaymentAddedSubscribe :showCheckout="showCheckout" />
        <div :class="`w-full  border-[1px] !rounded-2xl !rounded-bl-none ${routeLink}-border  mt-3`" dark v-motion :initial="{
            y: 100,
            opacity: 0,
        }" :enter="{
    y: 0,
    opacity: 1,
    transition: {
        duration: 300,
        type: 'keyframes',
        ease: 'easeInOut',
        delay: `100`
    },
}">
            <div :class="` p-3 flex items-center justify-between border-b-[1px] ${routeLink}-border`">
                <div class="font-Handel text-lg">
                    Current Plan
                </div>
                <v-btn outlined dark class="!rounded-2xl !rounded-bl-none !rounded-tr-none" @click="layOutChange()" :color="colorAsRoute"
                    >Change</v-btn>
            </div>
            <div class="p-3">
                <v-skeleton-loader dark v-if="currentSubscriptionLoading" type="article"></v-skeleton-loader>
                <div v-else>
                    <h3 class="font-Handel text-lg !capitalize">{{ userData.plan_name }} Package</h3>
                    <div class="font-Nunito mt-3">
                        <div>
                            <div class="tracking-widest">Next billing date is {{ currentSubscription.next_billing_date }}
                            </div>
                            <div class="tracking-widest">You were charged {{ currentSubscription.next_billing_amount }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div :class="`w-full  border-[1px] !rounded-2xl !rounded-bl-none ${routeLink}-border  mt-3`" dark v-motion :initial="{
            y: 100,
            opacity: 0,
        }" :enter="{
    y: 0,
    opacity: 1,
    transition: {
        duration: 300,
        type: 'keyframes',
        ease: 'easeInOut',
        delay: `200`
    },
}">
            <div :class="` p-3 flex items-center justify-between border-b-[1px] ${routeLink}-border`">
                <div class="font-Handel text-lg">
                    Payment Details
                </div>
                <v-btn outlined dark class="!rounded-2xl !rounded-bl-none !rounded-tr-none" :color="colorAsRoute" :to="{
                    name: 'SelectedSetting',
                    params: {
                        type: routeLink,
                        setting: 'PaymentDetails',
                    },
                }">Edit</v-btn>
            </div>
            <div class="p-3">
                <h3 class="font-Handel text-lg">{{ userData.pm_cardholder_name }}</h3>
                <div class="font-Nunito mt-3">
                    <div class="tracking-widest">**** **** **** {{ userData.pm_last_four }} </div>
                    <div class="tracking-widest">Expires at {{ userData.pm_expiry }}</div>
                </div>
            </div>
        </div>
        <div :class="`w-full  border-[1px] !rounded-2xl !rounded-bl-none ${routeLink}-border  mt-3 mb-5`" dark v-motion
            :initial="{
                y: 100,
                opacity: 0,
            }" :enter="{
    y: 0,
    opacity: 1,
    transition: {
        duration: 300,
        type: 'keyframes',
        ease: 'easeInOut',
        delay: `300`
    },
}">
            <div :class="` p-3 flex items-center justify-between border-b-[1px] ${routeLink}-border`">
                <div class="font-Handel text-lg">
                    {{ !cancelSubscribtion ? 'Cancel' : 'Resume'
                    }} Subscription
                </div>
            </div>
            <div :class="`p-3 border-b-[1px] ${routeLink}-border`">

                <div class="font-Nunito mt-3">
                    <div v-if="!cancelSubscribtion" class="tracking-widest">After cancelling, you'll be on <strong
                            class="capitalize">{{
                                userData.plan_name }}</strong> Package until the end of the current
                        billing period.</div>
                    <div v-else-if="cancelSubscribtion" class="tracking-widest">Resume your <strong class="capitalize">{{
                        userData.plan_name }} Package</strong> subscription before {{ cancelSubscribtion }} to continue
                        enjoying our services.</div>
                </div>
            </div>
            <div class="p-3 flex justify-end">
                <v-btn outlined dark class="!rounded-2xl !rounded-bl-none !rounded-tr-none" :color="colorAsRoute"
                    @click.prevent="subscriptionCancelDialog = true">{{ !cancelSubscribtion ? 'Cancel' : 'Resume'
                    }} Subscription</v-btn>
            </div>
        </div>
        <SubscriptionCanellationDialog @closeDialog="subscriptionCancelDialog = false" @confirmDialog="cancelSubscribtionFn"
            :showModal="subscriptionCancelDialog" title="Subscription Cancellation"
            text="Are you sure you want to cancel your subscription?" :btnLoading="btnLoading" />
    </div>
</template>
<script>
import axios from 'axios';
import SubscriptionCanellationDialog from './SubscriptionCanellationDialog.vue';
import PaymentAddedSubscribe from '../payement_details/PaymentAddedSubscribe.vue';

export default {
    props: {},
    data() {
        return {
            subscriptionCancelDialog: false,
            btnLoading: false,
            showCheckout: false,
            currentSubscription: {},
            currentSubscriptionLoading: false,
            cancelSubscribtion: '',
        }
    },
    methods: {
        layOutChange(){
            if(this.$store.getters.isPremiumLayout){
                this.$store.dispatch('premiumLayout' , false)
            }
            this.$router.push({ name: 'Plan' })
        },
        async checkSubsciptionDate() {
            const { data } = await axios.get('user/subscribe-last')
            this.cancelSubscribtion = data.data.ends_at
            console.log(data.data.ends_at)
        },
        async checkCurrentSubsciption() {
            try {
                this.currentSubscriptionLoading = true
                const { data } = await axios.post('user/subscribe/next-bill')
                this.currentSubscription = data.data
                console.log(data.data)

            } catch (error) {
                console.log(error)
            } finally {
                this.currentSubscriptionLoading = false

            }

        },

        async cancelSubscribtionFn() {
            try {
                this.btnLoading = true;
                let cancelData
                if (!this.cancelSubscribtion) {
                    cancelData = await axios.post('user/subscribe/cancel', {
                        package: this.$store.getters.StateUser.data.plan_name
                    });
                } else {
                    cancelData = await axios.get('user/subscribe-resume')
                }
                console.log(cancelData)
                this.checkSubsciptionDate()
                if (cancelData.status == '200') {
                    const { data } = await axios.get('profiles')
                    this.$store.commit("setUser", data);
                    this.$toast(cancelData.data.message, {
                        position: "top-center",
                        timeout: 5000,
                        closeOnClick: true,
                        pauseOnFocusLoss: true,
                        pauseOnHover: true,
                        draggable: true,
                        draggablePercent: 0.6,
                        showCloseButtonOnHover: true,
                        hideProgressBar: true,
                        closeButton: "button",
                        icon: {
                            iconClass: "mdi mdi-check-circle-outline",
                            iconChildren: "",
                            iconTag: "i"
                        },
                        rtl: false
                    });
                }
                this.subscriptionCancelDialog = false
            } catch (error) {
                console.log(error.response)
            } finally {
                this.btnLoading = false;
            }

        }
    },
    computed: {
        userData() {
            return this.$store.getters.StateUser.data;
        },
        colorAsRoute() {
            if (this.routeLink == "straight") {
                return "#a07a1d";
            }
            else if (this.routeLink == "gay") {
                return "#88c3fa";
            }
            else if (this.routeLink == "lesbian") {
                return "#9e2eec";
            }
        },
    },
    mounted() {
        this.checkSubsciptionDate()
        this.checkCurrentSubsciption()
    },
    components: { SubscriptionCanellationDialog, PaymentAddedSubscribe }
}
</script>

<style scoped>
.v-skeleton-loader:deep(.v-skeleton-loader__article) {
    background-color: black !important;
}

.straight-border {
    border-color: #a07a1d !important;
}

.gay-border {
    border-color: #88c3fa !important;
}

.lesbian-border {
    border-color: #9e2eec !important;
}</style>